import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { useGetCustomer } from "../../../../api/customers";
import useCertificateOfOriginStore from "../../../../stores/certificateOfOriginStore";
import getFullAddress from "../../../../utils/customer";

export default function useCertifierForm() {
  const { data: customer } = useGetCustomer();
  const currentCertifier = useCertificateOfOriginStore((s) => s.certifier);
  const navigate = useNavigate();

  const initialValues = useMemo(
    () => ({
      company: currentCertifier?.company || customer?.companyName || "",
      name: currentCertifier?.name || customer?.name || "",
      role: currentCertifier?.role || "producer",
      address: currentCertifier?.address || getFullAddress(customer),
      phoneNumber: currentCertifier?.phoneNumber || customer?.phoneNumber || "",
      emailAddress: currentCertifier?.emailAddress || customer?.email || "",
      effectiveDate: currentCertifier?.effectiveDate || new Date().toISOString(),
      expirationDate: currentCertifier?.expirationDate || new Date().toISOString(),
    }),
    [customer, currentCertifier],
  );

  const handleSubmit = useCallback(
    (values, { setSubmitting }) => {
      setSubmitting(true);
      useCertificateOfOriginStore.getState().setCertifier(values);
      navigate("/dashboard/certificate-of-origin/generate/exporter-form/");
      setSubmitting(false);
    },
    [navigate],
  );

  return useMemo(
    () => ({
      initialValues,
      handleSubmit,
    }),
    [initialValues, handleSubmit],
  );
}
